import Notification from './Notification.js';

export class PostNotificationOptions {
    constructor() {
        this.postTypeEndpoint = 'posts';
        this.ctaLabel = 'Read Article';
        this.minPublishDate = new Date(Date.now() - (7 * 24 * 3600 * 1000)).toISOString();
        this.isServiceContent = true;
        this.isRecentPurchaseFilterEnabled = false;
    }

    setPostTypeEndpoint(postTypeEndpoint) {
        this.postTypeEndpoint = postTypeEndpoint;
        return this;
    }

    setCallToActionLabel(ctaLabel) {
        this.ctaLabel = ctaLabel;
        return this;
    }

    setMinimumPublishDate(minPublishDate) {
        this.minPublishDate = minPublishDate;
        return this;
    }

    disableAccessibleServicesFilter() {
        this.isServiceContent = false;
        return this;
    }

    enableRecentPurchaseFilter() {
        this.isRecentPurchaseFilterEnabled = true;
        return this;
    }
}

export class PostNotification extends Notification {
    static createFromPost(post, options) {
        return new PostNotification(
            `post-${ post.id }`,
            'post',
            post.title.rendered,
            Date.parse(post.date),
            post.link,
            options.ctaLabel,
        );
    }

    static async fetch(options) {
        const serviceIds = window.foolArchiveFilters.services.map(s => s.termId).join(',');
        if (serviceIds === '' && options.isServiceContent) {
            return [];
        }
        try {
            const url = new URL(`/premium/wp-json/wp/v2/${ options.postTypeEndpoint }`, window.location.origin);
            url.searchParams.set('per_page', '40');
            if (options.isServiceContent) {
                url.searchParams.set('service', serviceIds);
            }
            url.searchParams.set('_fields', 'id,date,link,title,excerpt,service');
            if (options.minPublishDate) {
                url.searchParams.set('after', options.minPublishDate);
            }
            if (options.isRecentPurchaseFilterEnabled) {
                url.searchParams.set('recent_purchase', 'true');
            }

            const response = await fetch(url, {
                headers: {
                    "X-WP-Nonce": window.foolNotificationBell.restApiNonce ?? '',
                },
            });
            if (response.ok) {
                const posts = await response.json();
                return posts.map(post => PostNotification.createFromPost(post, options));
            }
        } catch (error) {
            console.error(error.message);
        }
        return [];
    }
}
